var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vulnerability (2) 1",
    clipPath: "url(#clip0_555_425)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M62.597 43.6562C62.5698 43.105 62.115 42.6719 61.5631 42.6719H58.6025V44.7422H60.5776L60.674 46.7053C60.7296 47.8511 59.8458 48.8249 58.7 48.8804C58.6675 48.882 58.635 48.8828 58.6025 48.8829V50.9532C60.893 50.9516 62.7484 49.0933 62.7467 46.8029C62.7467 46.7374 62.745 46.6719 62.7419 46.6064L62.597 43.6562Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.70316 46.8132V44.7428H20.3011V42.6725H6.84384V14.7229C6.84578 13.0086 8.23511 11.6193 9.94936 11.6174V40.6022H12.0197V5.40633C12.0216 3.69208 13.411 2.30275 15.1252 2.30081H48.2507C49.965 2.30275 51.3543 3.69208 51.3562 5.40633V24.0394H53.4266V11.6174C55.1408 11.6193 56.5301 13.0086 56.5321 14.7229V30.2504H58.6024V14.7229C58.5992 11.8657 56.2838 9.55025 53.4266 9.54701V5.40633C53.4233 2.54912 51.1079 0.233704 48.2507 0.230469H15.1252C12.268 0.233704 9.95259 2.54912 9.94936 5.40633V9.54701C7.09215 9.55025 4.77673 11.8657 4.7735 14.7229V42.6725H1.66798C1.09631 42.6725 0.632812 43.136 0.632812 43.7077V46.8132C0.6354 49.099 2.48771 50.9513 4.7735 50.9539H23.4066V48.8835H4.7735C3.63067 48.8822 2.70445 47.956 2.70316 46.8132Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M39.9689 26.1094C32.5366 26.11 26.5122 32.1355 26.5127 39.5676C26.5133 46.9999 32.5388 53.0244 39.971 53.0238C47.0013 53.0233 52.8464 47.6113 53.3873 40.6018H53.4261V39.5666C53.4177 32.1378 47.3977 26.1178 39.9689 26.1094ZM39.9689 50.9535C33.6801 50.9535 28.582 45.8554 28.582 39.5666C28.582 33.2778 33.6801 28.1797 39.9689 28.1797C46.2577 28.1797 51.3558 33.2778 51.3558 39.5666C51.3487 45.8524 46.2547 50.9464 39.9689 50.9535Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.0898 4.37109H16.1602V6.44144H14.0898V4.37109Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M18.2305 4.37109H20.3008V6.44144H18.2305V4.37109Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M22.3711 4.37109H24.4414V6.44144H22.3711V4.37109Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M14.0898 8.51172H49.2857V10.5821H14.0898V8.51172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M54.8911 48.8841C56.643 46.0924 57.5707 42.8625 57.5669 39.5667C57.5669 29.8632 49.6725 21.9688 39.969 21.9688C30.2656 21.9688 22.3711 29.8632 22.3711 39.5667C22.3711 49.2701 30.2656 57.1646 39.969 57.1646C43.2649 57.1683 46.4947 56.2407 49.2865 54.4888L55.9774 61.1798C57.5328 62.7197 60.0422 62.7073 61.5821 61.1518C63.1112 59.6073 63.1112 57.1196 61.5821 55.5751L54.8911 48.8841ZM39.969 55.0942C31.3934 55.0942 24.4414 48.1423 24.4414 39.5667C24.4414 30.991 31.3934 24.0391 39.969 24.0391C48.5446 24.0391 55.4966 30.991 55.4966 39.5667C55.4869 48.1383 48.5406 55.0845 39.969 55.0942ZM58.7798 60.2701C58.2774 60.2715 57.7956 60.0719 57.4414 59.7158L50.996 53.2698C51.9809 52.4756 52.878 51.5785 53.6721 50.5937L60.1176 57.0391C60.8567 57.7782 60.8567 58.9765 60.1176 59.7158C59.7628 60.0706 59.2816 60.27 58.7798 60.2701Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M45.1457 38.5328V37.4976C45.1465 34.6391 42.8299 32.3211 39.9712 32.3203C38.1213 32.3198 36.4117 33.3067 35.487 34.9089L37.2791 35.9456C38.1355 34.4596 40.0345 33.9492 41.5205 34.8056C42.483 35.3604 43.0759 36.3867 43.0753 37.4976V38.5328H34.794C34.2223 38.5328 33.7588 38.9963 33.7588 39.5679V45.779C33.7588 46.3506 34.2223 46.8141 34.794 46.8141H45.1457C45.7174 46.8141 46.1808 46.3506 46.1808 45.779V39.5679C46.1808 38.9963 45.7174 38.5328 45.1457 38.5328ZM44.1105 44.7438H35.8291V40.6031H44.1105V44.7438Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M20.3009 18.8634V16.793C20.3009 15.0779 18.9105 13.6875 17.1954 13.6875C15.4802 13.6875 14.0898 15.0779 14.0898 16.793V18.8634C14.0898 20.5785 15.4802 21.9689 17.1954 21.9689C18.9105 21.9689 20.3009 20.5785 20.3009 18.8634ZM16.1602 18.8634V16.793C16.1602 16.2213 16.6237 15.7578 17.1954 15.7578C17.767 15.7578 18.2305 16.2213 18.2305 16.793V18.8634C18.2305 19.435 17.767 19.8985 17.1954 19.8985C16.6237 19.8985 16.1602 19.435 16.1602 18.8634Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M26.5117 16.793V18.8634C26.5117 20.5785 27.9021 21.9689 29.6172 21.9689C31.3324 21.9689 32.7227 20.5785 32.7227 18.8634V16.793C32.7227 15.0779 31.3324 13.6875 29.6172 13.6875C27.9021 13.6875 26.5117 15.0779 26.5117 16.793ZM30.6524 16.793V18.8634C30.6524 19.435 30.1889 19.8985 29.6172 19.8985C29.0456 19.8985 28.5821 19.435 28.5821 18.8634V16.793C28.5821 16.2213 29.0456 15.7578 29.6172 15.7578C30.1889 15.7578 30.6524 16.2213 30.6524 16.793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M42.9374 19.3802L44.7292 20.4174C45.0021 19.945 45.1457 19.409 45.1456 18.8634V16.793C45.1456 15.0779 43.7552 13.6875 42.0401 13.6875C40.3249 13.6875 38.9346 15.0779 38.9346 16.793V18.8634C38.9344 19.4089 39.0781 19.945 39.3508 20.4174L41.1429 19.3809C41.0515 19.2239 41.0039 19.0452 41.0049 18.8634V16.793C41.0049 16.2213 41.4684 15.7578 42.0401 15.7578C42.6118 15.7578 43.0753 16.2213 43.0753 16.793V18.8634C43.0762 19.0448 43.0287 19.2232 42.9374 19.3802Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M22.3711 14.7227H24.4414V20.9337H22.3711V14.7227Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M34.7939 14.7227H36.8643V20.9337H34.7939V14.7227Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M15.125 24.0391H17.1953V30.2501H15.125V24.0391Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M19.2656 24.0391H21.336V30.2501H19.2656V24.0391Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M14.0898 37.4962C14.0898 39.2113 15.4802 40.6017 17.1954 40.6017C18.9105 40.6017 20.3009 39.2113 20.3009 37.4962V35.4258C20.3009 33.7107 18.9105 32.3203 17.1954 32.3203C15.4802 32.3203 14.0898 33.7107 14.0898 35.4258V37.4962ZM16.1602 35.4258C16.1602 34.8542 16.6237 34.3907 17.1954 34.3907C17.767 34.3907 18.2305 34.8542 18.2305 35.4258V37.4962C18.2305 38.0678 17.767 38.5313 17.1954 38.5313C16.6237 38.5313 16.1602 38.0678 16.1602 37.4962V35.4258Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M47.2158 14.7227H49.2862V20.9337H47.2158V14.7227Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_555_425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62.1138,
    height: 62.1138,
    fill: "white",
    transform: "translate(0.632812 0.222656)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.12e67e874d10bc51ad759bdf4a359e09.svg";
export { ForwardRef as ReactComponent };